<div class="footer">
    Copyright HTP Tours © 2011-2020
    All rights reserved.
    <small>Privacy Policy | Terms of Use</small>
</div>